<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PortfolioNavigation from "@common/Components/PortfolioNavigation.vue";
    import { strCompareLowerCase } from '@common/Common';
    import { AllRelationshipsReadModel } from '@Alternatives/AlternativesLists/Domain/readmodels';
    import AlternativesListsQueries from '@Alternatives/AlternativesLists/Domain/queries-vue-component';
    import { AlternativeReadModel } from '@Alternatives/Alternatives/Domain/readmodels';


    @Component({
        components: {
            PortfolioNavigation
        }
    })
    export default class RelationshipsPage extends mixins(AlternativesListsQueries)
    {
        get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
        get projectId(): number { return Number.parseInt(this.$route.params.projectId); }

        rm: AllRelationshipsReadModel = null;

        AlternativesListId: number;
        Filter: string = 'All';
        ViewBy: string = 'Foundation';

        get FoundationsView() 
        {
            let view = this.rm.Alternatives.filter(a => a.DependentsIds.length > 0);

            if (this.Filter === 'Issues')
            {
                view = view.filter(a => this.getDependents(a).some(b => b.StatusId !== a.StatusId));
            }

            return view.sort((a, b) => strCompareLowerCase(a.Name, b.Name));
        }

        get DependentsView() 
        {
            let view = this.rm.Alternatives.filter(a => a.FoundationsIds.length > 0);

            if (this.Filter === 'Issues')
            {
                view = view.filter(a => this.getFoundations(a).some(b => b.StatusId !== a.StatusId));
            }

            return view.sort((a, b) => strCompareLowerCase(a.Name, b.Name));
        }


        getDependents(rm: AlternativeReadModel) { return this.rm.Alternatives.filter(a => rm.DependentsIds.includes(a.AlternativeId)); }

        getFoundations(rm: AlternativeReadModel) { return this.rm.Alternatives.filter(a => rm.FoundationsIds.includes(a.AlternativeId)); }


        toggleViewBy()
        {
            if (this.ViewBy === 'Foundation')
            {
                this.ViewBy = 'Dependent';
            }
            else
            {
                this.ViewBy = 'Foundation';
            }
        }

        toggleFilter()
        {
            if (this.Filter === 'All')
            {
                this.Filter = 'Issues';
            }
            else
            {
                this.Filter = 'All';
            }
        }

        
        mounted()
        {   
            document.title = "Dependencies | TransparentChoice";
            this.runRelationshipsByProjectIdQueryV1(this.workspaceId, this.projectId);
        }

        onSetModel(model: any, modelName: string) 
        {
            if (modelName == "AllRelationshipsReadModel")
            {
                this.rm = model as AllRelationshipsReadModel;
            }
        }
    }

</script>

<template>
    <div>
        <PortfolioNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <div class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Dependencies</h1>
                </div>
                <div class="col-lg-6 text-right"></div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 60px;" />

        <div class="container" v-if="rm">
            <button class="btn btn-outline-secondary" @click="toggleViewBy">View by: {{ViewBy}}</button>
            <button class="btn btn-outline-secondary" @click="toggleFilter">Filter: {{Filter}}</button>
            <br /><br />

            <table class="table table-hover" v-if="ViewBy === 'Foundation'">
                <thead>
                    <tr>
                        <th>Foundation</th>
                        <th>Dependents</th>
                    </tr>
                </thead>

                <tbody v-for="f in FoundationsView" :key="f.AlternativeId">
                    <tr>
                        <td>
                            <a v-sanitizedHref="`/#/alternative/dashboard/${workspaceId}/${projectId}/${f.Id}`">{{f.Name}}</a>
                        </td>
                        <td>
                            <span v-for="d in getDependents(f)" :key="d.Id">
                                <a v-sanitizedHref="`/#/alternative/dashboard/${workspaceId}/${projectId}/${d.Id}`">{{d.Name}}</a>, 
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <table class="table table-hover"  v-if="ViewBy === 'Dependent'">
                <thead>
                    <tr>
                        <th>Dependent</th>
                        <th>Foundations</th>
                        <th style="width: 100px;"></th>
                    </tr>
                </thead>
                <tbody v-for="d in DependentsView" :key="d.AlternativeId">
                    <tr>
                        <td>
                            <a v-sanitizedHref="`/#/alternative/dashboard/${workspaceId}/${projectId}/${d.Id}`">{{d.Name}}</a>
                        </td>
                        <td>
                            <span v-for="f in getFoundations(d)" :key="f.Id">
                                <a v-sanitizedHref="`/#/alternative/dashboard/${workspaceId}/${projectId}/${f.Id}`">{{f.Name}}</a>,
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>


    </div>
</template>

<style scoped>

</style>


